const styles = {
  custom_container: "w-11/12 hidden sm:block",
  heading:
    "text-[27px] text-left md:text-start font-[600] font-Poppins",
  section: "w-11/12 mx-auto",
  productTitle: "text-[25px] font-[600] font-Poppins text-[#333] mb-3",
  productDiscountPrice:
    "font-bold text-[12px] sm:text-[15px] lg:text-[18px] leading-none text-[#333] font-Poppins whitespace-nowrap",
  price:
    "font-[500] text-[10px] sm:text-[13px] lg:text-[16px] leading-none text-[#d55b45] pl-1 sm:pl-2 lg:pl-3 mt-[-1px] sm:mt-[-2px] lg:mt-[-4px] line-through whitespace-nowrap",
  shop_name: "pt-3 text-[12px] text-[#38513B] pb-3 font-[500]",
  active_indicator: "absolute bottom-[-27%] left-0 h-[3px] w-full bg-[#38513b]",
  button:
    "w-[200px] bg-black h-[50px] my-3 flex items-center justify-center rounded-xl cursor-pointer font-[600]",
  cart_button:
    "px-[20px] h-[38px] rounded-[20px] bg-[#38513B] flex items-center justify-center cursor-pointer",
  cart_button_text: "text-[#fff] text-[16px] font-[600]",
  input: "w-full border p-1 rounded-[5px]",
  activeStatus:
    "w-[10px] h-[10px] rounded-full absolute top-0 right-1 bg-[#40d132]",
  noramlFlex: "flex items-center",
};

export default styles;
